angular.module('ihestiaCommonDirectives.trimInfo', []);